/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Type of orientation for the Tabs Extended
 */
export enum ORIENTATION {
  /**
   * Horizontal (default)
   */
  HORIZONTAL = 'horizontal',

  /**
   * Vertical
   */
  VERTICAL = 'vertical',
}

/**
 * Tabs types.
 */
export enum TABS_TYPE {
  /**
   * Regular tabs.
   */
  REGULAR = '',

  /**
   * Contained type.
   */
  CONTAINED = 'contained',
}
